import { Button } from '../../components/ui/button';
import { useAcceptInvitation, useMyInvitations } from './use-my-invitations';

export function PendingInvitationsBanner() {
  const { data: invitations } = useMyInvitations();
  const acceptInvitation = useAcceptInvitation();

  if (!invitations || invitations.length === 0) {
    return null;
  }

  return (
    <div className="mb-4 rounded-lg border border-accent/20 bg-accent/[0.07] p-3">
      <p className="text-xs font-medium text-[#ededf0]">
        Du har {invitations.length} ventende{' '}
        {invitations.length === 1 ? 'invitasjon' : 'invitasjoner'}
      </p>
      <div className="mt-3 flex flex-col gap-2">
        {invitations.map((invitation) => (
          <div key={invitation.id} className="flex items-center justify-between gap-3">
            <span className="truncate text-xs text-[#8b8d9a]">
              Sak {invitation.caseId} · {invitation.role}
            </span>
            <Button
              className="px-3 py-1 text-xs"
              disabled={acceptInvitation.isPending}
              onClick={() => acceptInvitation.mutate({ invitationId: invitation.id })}
            >
              Aksepter
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
}
